import { render, staticRenderFns } from "./NotesAndReferenceNumber.vue?vue&type=template&id=e053142c"
import script from "./NotesAndReferenceNumber.vue?vue&type=script&lang=js"
export * from "./NotesAndReferenceNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports